var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m698.6 807.7 245-246.4v814.5h169.8V565.1L1360 807.7l110.9-110.9-444.3-440.2-110.8 110.9-328 329.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1582.5 1279.1v316.8h-1117v-316.8H257.9v512.3h1532.2v-512.3z"
}))));
export default SvgUpload;